export const FEATURE_NAME: string = 'auth-feature';

export interface IAuthState {
  isAuthenticated: boolean;
}

export const initialAuthState: IAuthState = {
  isAuthenticated: false,
};
